import { Plugin } from 'vue';
import * as UiIcons from '@/ui/icons';

export const icons: Plugin = {
  install: (app) => {
    Object.entries(UiIcons).map(([name, component]) => {
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      app.component(name, component as any);
    });
  },
};
